import React, { useState, useEffect, useRef, useMemo } from 'react';
import styles from './LobbyTicker.module.css';

const GENERIC_TIPS = [
    "Aim for the back cup to open up the rack",
    "A save can turn the tide — don't give up on a shot",
    "Communicate with your teammate between turns",
    "Heating up? Call your next cup for bonus pressure",
    "beer.",
    "Arin, where's my McDonalds",
    "I'm hammmereddddddd -Undy",
    "Zager",
    "I wonder what happens if you lap your oponents",
    "2 halves or 1 fer",
    "Eye contact with the ball, not the table",
    "Front cups are easy — back cups win games",
    "Stay composed after a bad turn. Your next shot is coming",
    "Winter is coming",
    "Zero bitches tn huh",
];

function shuffle(arr) {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

function buildMessages(playerStats, slots) {
    const dynamic = [];

    slots.forEach(slot => {
        const stats = playerStats[slot.username];
        if (!stats) return;
        const name = slot.username;
        const games = stats.total_games_completed ?? 0;

        if (games >= 5) {
            const pct = Math.round(parseFloat(stats.winning_percentage) * 100);
            dynamic.push(`${name} wins ${pct}% of their games`);
        }

        const cpg = parseFloat(stats.total_cups_per_game ?? 0);
        if (cpg > 0) {
            dynamic.push(`${name} averages ${cpg.toFixed(1)} cups per game`);
        }

        if ((stats.saves ?? 0) > 0) {
            dynamic.push(`${name} has ${stats.saves} career saves`);
        }

        if ((stats.laps_given ?? 0) > 0) {
            dynamic.push(`${name} has lapped opponents ${stats.laps_given} time${stats.laps_given !== 1 ? 's' : ''}`);
        }

        if ((stats.laps_received ?? 0) > 0) {
            dynamic.push(`${name} has been lapped ${stats.laps_received} time${stats.laps_received !== 1 ? 's' : ''} 😬`);
        }

        if ((stats.own_cups ?? 0) > 0) {
            dynamic.push(`${name} has accidentally sunk ${stats.own_cups} own cup${stats.own_cups !== 1 ? 's' : ''} 💀`);
        }

        if (games > 0 && games < 5) {
            dynamic.push(`${name} has played ${games} game${games !== 1 ? 's' : ''} so far`);
        }
    });

    // Interleave tips and dynamic messages, shuffle each group independently
    const shuffledTips = shuffle(GENERIC_TIPS);
    const shuffledDynamic = shuffle(dynamic);

    const merged = [];
    const max = Math.max(shuffledTips.length, shuffledDynamic.length);
    for (let i = 0; i < max; i++) {
        if (i < shuffledDynamic.length) merged.push(shuffledDynamic[i]);
        if (i < shuffledTips.length) merged.push(shuffledTips[i]);
    }

    return merged;
}

const LobbyTicker = ({ playerStats, slots }) => {
    const messages = useMemo(
        () => buildMessages(playerStats, slots),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(playerStats), JSON.stringify(slots)]
    );

    const [index, setIndex] = useState(0);
    const [visible, setVisible] = useState(true);
    const timerRef = useRef(null);

    useEffect(() => {
        if (messages.length <= 1) return;

        timerRef.current = setInterval(() => {
            if (document.hidden) return;
            setVisible(false);
            setTimeout(() => {
                setIndex(prev => (prev + 1) % messages.length);
                setVisible(true);
            }, 400);
        }, 4000);

        return () => clearInterval(timerRef.current);
    }, [messages]);

    if (messages.length === 0) return null;

    return (
        <div className={styles.ticker}>
            <div className={styles.header}>
                <span className={styles.icon}>⚡</span>
                <span className={styles.label}>LOBBY INTEL</span>
            </div>
            <p className={`${styles.message} ${visible ? styles.visible : styles.hidden}`}>
                {messages[index]}
            </p>
            {messages.length > 1 && (
                <div className={styles.dots}>
                    {messages.map((_, i) => (
                        <span
                            key={i}
                            className={`${styles.dot} ${i === index ? styles.dotActive : ''}`}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default LobbyTicker;
